import { MayBeNull } from '@wpp-open/core'

export enum EventsType {
  Login = 'user_login',
  Segment = 'segment_interaction',
  Page = 'virtual_page_view',
  AppLaunch = 'os_app_launch',
}

export interface GA4Action {
  event: string
  user_id: string
  source?: string
  segment_action_name?: string
}

export interface GA4AuthAction extends GA4Action {
  user_agency?: string
  user_company?: string
  user_department?: MayBeNull<string>
  user_job_role?: MayBeNull<string>
  user_region?: MayBeNull<string>
  user_country?: MayBeNull<string>
  user_first_name?: MayBeNull<string>
  user_last_name?: MayBeNull<string>
}

export interface GA4OpenAppAction extends GA4Action {
  user_agency?: string
  user_company?: string
  user_department?: MayBeNull<string>
  user_job_role?: MayBeNull<string>
  user_region?: MayBeNull<string>
  user_country?: MayBeNull<string>
  user_first_name?: MayBeNull<string>
  user_last_name?: MayBeNull<string>
  context_type?: MayBeNull<string>
  context_name?: MayBeNull<string>
  tenant_name?: MayBeNull<string>
  application_id: string
  application_name?: MayBeNull<string>
  application_source?: MayBeNull<string>
  application_launched_from?: MayBeNull<string>
  application_instance_id?: MayBeNull<string>
  feature?: MayBeNull<string>
  client?: MayBeNull<string>
  brand?: MayBeNull<string>
  client_alias?: MayBeNull<string>
  brand_alias?: MayBeNull<string>
  market?: MayBeNull<string>
  market_alias?: MayBeNull<string>
  industry?: MayBeNull<string>
  industry_alias?: MayBeNull<string>
  region?: MayBeNull<string>
  regionAlias?: MayBeNull<string>
  project?: MayBeNull<string>
  product_category?: MayBeNull<string>
  product_subcategory?: MayBeNull<string>
}

export interface GA4PageViewAction extends GA4Action {
  pageUrl?: MayBeNull<string>
  pageTitle?: MayBeNull<string>
  previousUrl?: MayBeNull<string>
  workspace_market?: MayBeNull<string>
  workspace_industry?: MayBeNull<string>
  workspace_brand?: MayBeNull<string>
  workspace_client?: MayBeNull<string>
  workspace_region?: MayBeNull<string>
  workspace_custom?: MayBeNull<string>
  context_type?: MayBeNull<string>
  project?: MayBeNull<string>
  tenant_name?: MayBeNull<string>
}
